import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useParams, Link } from "react-router-dom";
import { Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

import { getDataByCategory } from "../../../services/database/database_service";
import LoadingIndicator from "../components/LoadingIndicator";
import { setSigns } from "../../../store/signSlice";
import ln from "../../../assets/lines/line.png";
import { useLanguage } from "../../../services/localization/LanguageContex";



function SignsSubScreenOne() {
  const { language, t } = useLanguage();
  const dispatch = useDispatch();

  const { category } = useParams();
  const categoryItemList = useSelector((state) => state.sign.signs);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    // window.scrollTo({ top: 0, behavior: "smooth" });
    async function fetchSignsByCategory() {
      try {
        const data = await getDataByCategory(category);
        dispatch(setSigns(data.documents));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchSignsByCategory();
  }, [dispatch]);


  return (
    <Box
      // sx={{
      //   px: 6,
      //   pt: 2,
      // }}
      sx={{ px: { xs: 3, sm: 6, md: 6 }, pt: 2 ,pb:6}}
    >
      <Typography
        variant="h4"
        gutterBottom
        align="center"
        style={{ marginBottom: 15 }
      
      }
      >
        {/* {category.replace(/\b\w/g, (char) => char.toUpperCase())} */}
        {t(category)}
      </Typography>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <LoadingIndicator />
          </Box>
        ) : error ? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h6" color="error">
              {error}
            </Typography>
          </Box>
        ) : categoryItemList.length === 0 ? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h6" color="textSecondary" gutterBottom>
              No signs found in this category yet.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Please check back later as we continue to add more.
            </Typography>
          </Box>
        ) : (
          <>
            <Box
              component="img"
              src={ln}
              alt="line"
              loading="lazy"
              sx={{
                height: 35,
                mb: 1,
              }}
            />
            <List>
              {categoryItemList.map((item) => (
                <div key={item.$id}>
                  <Link
                    to={`/home/signsCategory/${encodeURIComponent(
                      category
                    )}/${encodeURIComponent(item.enTitle)}`}
                    style={{ textDecorationLine: "none", color: "black" }}
                  >
                    <ListItem>
                      <ListItemText 
                      // fist check dzTitle, if not available then use from translation.js , if not then use enTitle
                      primary=
                     
                      // {language === "en" 
                      //   ? item.enTitle.charAt(0).toUpperCase() + item.enTitle.slice(1)
                      //   : item.dzTitle 
                      //     ? item.dzTitle 
                      //     : (t(item.enTitle) !== item.enTitle 
                      //         ? t(item.enTitle) 
                      //         : item.enTitle.charAt(0).toUpperCase() + item.enTitle.slice(1)
                      //       )
                      // }

                                           
                      {language === "en" 
                        ? item.enTitle
                        : item.dzTitle 
                          ? item.dzTitle 
                          : t(item.enTitle) 
                      }

                      style={{marginRight:20}}
                      
                      />

                      <ArrowForwardIcon />
                    </ListItem>
                  </Link>

                  <Divider variant="middle" component="li" />
                </div>
              ))}
            </List>
          </>
        )}
      </div>
    </Box>
  );
}

export default SignsSubScreenOne;
